import React, { useState } from 'react';
import MaquinaDiaGraficas from './graficas/maquina-dia-graficas';
import { Paper, Grid, Box, TextField, MenuItem, FormControl, InputLabel, Select, Typography } from '@mui/material';

const maquinasEjemplo = [
  'Machine1', 'Machine2', 'Machine3', 'Machine4', 'Machine5', 'Machine6', 'Machine7', 'Machine8'
];


const MaquinaDiaPage = () => {
  // Leer filtros guardados en localStorage (si existen)
  const filtrosGuardados = (() => {
    try {
      return JSON.parse(localStorage.getItem('filtrosMaquinaDia')) || {};
    } catch {
      return {};
    }
  })();
  const [fecha, setFecha] = useState(filtrosGuardados.fecha || '');
  const [maquina, setMaquina] = useState(filtrosGuardados.maquina || '');

  // Guardar filtros en localStorage cada vez que cambian
  React.useEffect(() => {
    localStorage.setItem('filtrosMaquinaDia', JSON.stringify({ fecha, maquina }));
  }, [fecha, maquina]);

  return (
    <Paper sx={{ p: 3, mt: 2, maxWidth: 1600, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom align="center">Gráficas por Máquina Día</Typography>
      <Box sx={{ mb: 3 }}>
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={4} lg={3}>
            <TextField
              label="Fecha"
              type="date"
              value={fecha}
              onChange={e => setFecha(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <FormControl fullWidth>
              <InputLabel id="maquina-label">Máquina</InputLabel>
              <Select
                labelId="maquina-label"
                value={maquina}
                label="Máquina"
                onChange={e => setMaquina(e.target.value)}
              >
                <MenuItem value=""><em>Todas</em></MenuItem>
                {maquinasEjemplo.map(m => (
                  <MenuItem key={m} value={m}>{m}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      <MaquinaDiaGraficas fecha={fecha} maquina={maquina} />
    </Paper>
  );
};

export default MaquinaDiaPage;
